import React from "react";
import { useNavigate } from "react-router-dom";
import "./testseriescard.css";
import ssc from "../../assets/test-series-image/ssc.webp";
import rrb from "../../assets/test-series-image/rrb.webp";
import mpsc from "../../assets/test-series-image/mpsc.webp";
import Police from "../../assets/test-series-image/police.webp";
import bank from "../../assets/test-series-image/bank.webp";
import coding from "../../assets/test-series-image/coding.webp";
import campus from "../../assets/test-series-image/campus.webp";
import jee from "../../assets/test-series-image/jee.webp";
function TestSeriesCard({ img, text, onClick }) {
  return (
    <div className="test-series-box" onClick={onClick}>
      <img src={img} alt={text} className="test-series-img" />
      <div className="test-series-text">
        <p>{text}</p>
      </div>
    </div>
  );
}

function TestSeriesCards() {
  const navigate = useNavigate();

  const testSeriesData = [
    { img: ssc, text: "SSC Exams", url: "/ssc" },
    { img: rrb, text: "RRB Exams", url: "/rrb" },
    { img: mpsc, text: "MPSC Exams", url: "/mpsc" },
    { img: Police, text: "Police Exams", url: "/police" },
    { img: bank, text: "Banking Exams", url: "/banking" },
    { img: coding, text: "Coding Exams", url: "/coding" },
    { img: campus, text: "Placement", url: "/placement" },
    { img: jee, text: "JEE Exam", url: "/jee" },
  ];

  return (
    <div className="test-series-container">
      <h2 className="popular-Test">Popular Test Series</h2>
      <section className="test-series-status">
        <div className="row">
          {testSeriesData.map((series, index) => (
            <TestSeriesCard
              key={index}
              img={series.img}
              text={series.text}
              onClick={() => navigate(`/testseries${series.url}`)}
            />
          ))}
        </div>
      </section>
    </div>
  );
}

export default TestSeriesCards;